module.exports = __webpack_public_path__ + "static/media/rCandle.14b3ce12.png";